module.exports = "/static/assets/33656936f6eb527d56d75904e3c22504.png";